import React from 'react';
import './App.css';
import CrypticCrosswordGame from './CrypticCrosswordGame';

function App() {
  return (
    <div className="App">
      <CrypticCrosswordGame />
    </div>
  );
}

export default App;